/**
 * ProtectedRoute — bounces an unauthenticated visitor into Auth0 and holds a
 * spinner until the SDK settles.
 *
 * Extracted from `App.tsx` unchanged (BON-472): that file declared four
 * components, which `react/no-multi-comp` now rejects, and mounting the toast
 * provider meant touching it.
 */
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      const params = new URLSearchParams({
        error: (error as { error?: string }).error ?? error.name,
        error_description: error.message,
      });
      navigate(`/error?${params}`, { replace: true });
      return;
    }
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, error, navigate]);

  if (isLoading || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-page">
        <div className="w-8 h-8 border-2 border-moss-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
}
